module.exports = "../../map/Nagano/map/agriculture/Nagano_AgricultureOrange_CMIP5RCP85_MIROC_No_R2081_2100.png";